import { apiClient } from './client';

/** Feature flags the frontend mirrors from the backend (GET /api/features). */
export interface FeaturesResponse {
  features: {
    validates_product_images: boolean;
    bcrs_deposit: boolean;
    display_attachment_upload: boolean;
    link_spine_order_to_event: boolean;
    gathering_box: boolean;
    bundles: boolean;
  };
}

export const features = {
  get: () => apiClient.get<FeaturesResponse>('/api/features'),
};
